export enum TrackingEvent {
  ViewedSupplierMedia = 'Viewed supplier logged out media',
  ClickedExternalLinkWithinArticle = 'Clicked external link within article',
  ViewedSupplierProfileOnLoggedOutPage = 'Viewed supplier profile on logged out page',
  ClickedOnLoggedOutPage = 'Clicked on logged out page',
  LoadedSearchResultsOnLoggedOutPage = 'Loaded search results on logged out page',
  ReadArticleOnLoggedOutPage = 'Read article on logged out page',
  ViewedLoggedOutPage = 'Viewed logged out page',
  Clicked = 'Clicked',
  ViewedSupplierInSearch = 'Viewed supplier in search',
}
